<template>
  <div class="stars">
    <span
      v-for="n in stars"
      :key="`star-${n}`"
    />
    <template v-if="showEmpty && stars < 5">
      <span
        v-for="n in (5 - stars)"
        :key="`star-empty-${n}`"
        class="empty"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'stars',
  props: {
    stars: {
      type: Number,
      required: true,
    },
    showEmpty: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.stars {
  display: inline-flex;

  span {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 2px;
    background-image: url('../../assets/icons/star.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    &.empty {
      background-image: url('../../assets/icons/star-empty.png');
    }
  }
}
</style>
